import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import CloseCardsListIcon from "@components/Svg/CloseCardsListIcon";
import { PrimaryButton } from "@components/UI/Buttons/PrimaryButton/PrimaryButton";
import { createLabel } from "@src/utils/utils";
import Car from "@shared/lib/interfaces/car.interface";
import VerticalCatalogCardMap from "../vertical-catalog-card-map/vertical-catalog-card-map";
import { MapViewCardsListProps } from "./types";
import "simplebar-react/dist/simplebar.min.css";
import classes from "./map-view-cards-list.module.scss";

const MapViewCardsList = ({
    isContentLoading,
    closeAdsBlock,
    currentOffers = [],
    metaTotal,
    onLoadMore,
    currentPage
}: MapViewCardsListProps) => {
    const [offers, setOffers] = useState<Car[]>([]);
    const totalOffers = metaTotal || 0;

    const canLoadMore = offers.length < totalOffers;

    const handleShowMore = () => {
        if (canLoadMore) {
            onLoadMore();
        }
    };

    useEffect(() => {
        setOffers((prev) => {
            if (currentPage === 1) {
                return currentOffers;
            }
            return [...prev, ...currentOffers];
        });
    }, [currentOffers]);

    return (
        <div className={classes.MapViewCardsList}>
            {isContentLoading && (
                <div className={classes.LoaderCont}>
                    <div className={classes.Loader}></div>
                </div>
            )}

            <div className={classes.CardsHeader}>
                <label>
                    {offers.length}{" "}
                    {createLabel(offers.length, ["объявление", "объявления", "объявлений"])} из{" "}
                    {totalOffers}
                </label>
                <div className={classes.CloseBtn} onClick={closeAdsBlock}>
                    <CloseCardsListIcon />
                </div>
            </div>
            <SimpleBar className={classes.CardsListContainer}>
                {offers.map((car) => {
                    return <VerticalCatalogCardMap offer={car} key={car.id} />;
                })}
                {canLoadMore && (
                    <PrimaryButton
                        className={classes.LoadMoreButton}
                        content={"Показать ещё"}
                        onClick={handleShowMore}
                    />
                )}
            </SimpleBar>
        </div>
    );
};

export default MapViewCardsList;